define("analytics-resources/utils/constants", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ANALYTICS_COLOR_NAMES_LIST = _exports.ANALYTICS_COLOR_LIST = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Defines the color constants used across the analytics platform.
   *
   * These colors are based on the analytics theme defined in the SCSS variables file
   * located at `app/styles/app2/variables.scss` and are used throughout the application
   * to maintain consistency in the visual representation of analytics data.
   *
   * Usage References:
   * - `$CCH_COLOR_LIST` in `lib/analytics-resources/app/styles/analytics-resources/c/charts.scss`
   * - `.tAN--legend__color` in `lib/analytics-resources/app/styles/analytics-resources/t/analytics.scss`
   * - `.tAN--table__heatmap` in `lib/analytics-resources/app/styles/analytics-resources/t/analytics.scss`
   * - `.cCH--barChart__meterGauge` in `lib/analytics-resources/app/styles/analytics-resources/c/charts.scss`
   */
  const ANALYTICS_COLOR_LIST = _exports.ANALYTICS_COLOR_LIST = {
    YELLOW: '#ffc700',
    BLUE: '#389cfd',
    LIGHT_BLUE: '#c8e1ff',
    FACEBOOK_BLUE: '#2C4AAA',
    CARIBBEAN_GREEN: '#08c787',
    TEAL: '#3fc5d3',
    GREEN: '#08adc7',
    LIME_GREEN: '#7BD642',
    DARK_GREEN: '#138501',
    LIGHT_GREEN: '#c8ffd4',
    PURPLE: '#a35cff',
    PURPLE_DARK: '#4c35dc',
    PURPLE_LIGHT: '#d2b3fd',
    PINK: '#fe258a',
    RED: '#dc0f0f',
    LIGHT_RED: '#ffc8c8',
    GREY: '#f3f6f9',
    GREY_DARK: '#BBCBDA',
    PARTIAL: '#dce4ec',
    DISABLED: '#eef6fe',
    TRANSPARENT: 'rgba(0, 0, 0, 0)'
  };
  const ANALYTICS_COLOR_NAMES_LIST = _exports.ANALYTICS_COLOR_NAMES_LIST = {
    YELLOW: 'yellow',
    BLUE: 'blue',
    FACEBOOK_BLUE: 'facebookBlue',
    LIGHT_BLUE: 'lightBlue',
    CARIBBEAN_GREEN: 'caribbeanGreen',
    TEAL: 'teal',
    GREEN: 'green',
    LIME_GREEN: 'limeGreen',
    DARK_GREEN: 'darkGreen',
    LIGHT_GREEN: 'lightGreen',
    PURPLE: 'purple',
    PURPLE_DARK: 'purpleDark',
    PURPLE_LIGHT: 'purpleLight',
    PINK: 'pink',
    RED: 'red',
    LIGHT_RED: 'lightRed',
    GREY: 'grey',
    GREY_DARK: 'greyDark',
    PARTIAL: 'partial',
    DISABLED: 'disabled',
    TRANSPARENT: 'transparent'
  };
});